<template>
  <div>
    <van-nav-bar
      :title="title"
      left-text="返回"
      left-arrow
      @click-left="$router.push('/quotes')"
      class=""
    />
    <van-list
      v-model="loadingQuotesDetails"
      :finished="finishedQuotesDetails"
      finished-text=""
      @load="onLoad"
    >
      <van-row class="tableTitle">
        <van-col span="8" style="text-align: left"
          ><span>{{ columnTitleOne }}</span></van-col
        >
        <van-col span="8" style="text-align: center"
          ><span>{{ columnTitleTwo }}</span></van-col
        >
        <van-col span="8" style="text-align: right"
          ><span>{{ columnTitleThree }}</span></van-col
        >
      </van-row>
      <div v-for="(item, index) in dataList" :key="index" @click="onItem(item)">
        <van-row class="tablecontent"
          ><van-col span="8"
            ><span>{{ item.name }}<br />{{ item.code }}</span></van-col
          >
          <van-col span="8" style="padding-top: 10px; text-align: center"
            ><span
              v-bind:class="[
                item.zhi3.substring(0, 1) == '-' ? 'greenText' : 'redText',
              ]"
              >{{ item.zhi1 }}</span
            ></van-col
          >
          <van-col span="8" style="padding-top: 10px; text-align: right"
            ><span
              v-bind:class="[
                item.zhi3.substring(0, 1) == '-' ? 'greenText' : 'redText',
              ]"
              >{{
                item.zhi2 !== null
                  ? item.zhi2
                  : "--"
              }}</span
            ></van-col
          >
        </van-row>
      </div>
    </van-list>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  name: "QuotesDetails",
  data() {
    return {
      title: "",
      dataList: "",
      quotesId: sessionStorage.getItem("quotesId"),
      loadingQuotesDetails: false,
      finishedQuotesDetails: false,
      page: 1,
      columnTitleOne: "",
      columnTitleTwo: "",
      columnTitleThree: "",
    };
  },
  methods: {
    onItem(item) {
      this.$router.push({
        name: "Kline",
        params: { code: item.shortCode },
      });
    },
    get_all_stock() {
      let that = this;
      that.loadingQuotesDetails = true;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "stock_page_data",
            action: "all_stock",
            page: that.page,
            num: 40,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            if (res.data.data.length == 0) {
              that.finishedQuotesDetails = true;
            } else {
              res.data.data.forEach((e) => {
                that.dataList.push(e);
              });
              that.page++;
            }
            that.loadingQuotesDetails = false;
          } else if (res.data.code == 0) {
            that.$toast.fail(res.data.msg);
          }
        })
        .finally(() => {
          that.loadingQuotesDetails = false;
        });
      // $.ajax({
      //   cache: true,
      //   url:
      //     "https://vip.stock.finance.sina.com.cn/quotes_service/api/json_v2.php/Market_Center.getHKStockData?page=" +
      //     that.pageCount +
      //     "&num=40&sort=symbol&asc=1&node=qbgg_hk&_s_r_a=init",
      //   type: "GET",
      //   dataType: "json",
      //   success: function (data) {
      //     if (data.length == 0) {
      //       that.finishedQuotesDetails = true;
      //       return;
      //     }
      //     data.forEach((i) => {
      //       that.list.push(i);
      //     });
      //     that.loadingQuotesDetails = false;
      //     that.pageCount++;
      //   },
      // });
    },
    get_hot_hk() {
      let that = this;
      that.loadingQuotesDetails = true;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "stock_page_data",
            action: "hot_hk",
            page: that.page,
            num: 40,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            if (res.data.data.length == 0) {
              that.finishedQuotesDetails = true;
            } else {
              res.data.data.forEach((e) => {
                that.dataList.push(e);
              });
              that.page++;
            }
            that.loadingQuotesDetails = false;
          } else if (res.data.code == 0) {
            that.$toast.fail(res.data.msg);
          }
        })
        .finally(() => {
          that.loadingQuotesDetails = false;
        });
      // $.ajax({
      //   cache: true,
      //   url:
      //     "https://vip.stock.finance.sina.com.cn/quotes_service/api/json_v2.php/Market_Center.getHKStockData?page=" +
      //     that.pageCount +
      //     "&num=40&sort=symbol&asc=1&node=hot_hk&_s_r_a=init",
      //   type: "GET",
      //   dataType: "json",
      //   success: function (data) {
      //     if (data.length == 0) {
      //       that.finishedQuotesDetails = true;
      //       return;
      //     }
      //     data.forEach((i) => {
      //       that.list.push(i);
      //     });
      //     that.loadingQuotesDetails = false;
      //     that.pageCount++;
      //   },
      // });
    },
    get_hk_up() {
      let that = this;
      that.loadingQuotesDetails = true;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "stock_page_data",
            action: "stock_hk_up",
            page: that.page,
            num: 40,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            if (res.data.data.length == 0) {
              that.finishedQuotesDetails = true;
            } else {
              res.data.data.forEach((e) => {
                that.dataList.push(e);
              });
              that.page++;
            }
            that.loadingQuotesDetails = false;
          } else if (res.data.code == 0) {
            that.$toast.fail(res.data.msg);
          }
        })
        .finally(() => {
          that.loadingQuotesDetails = false;
        });
      // $.ajax({
      //   cache: true,
      //   url:
      //     "https://vip.stock.finance.sina.com.cn/quotes_service/api/json_v2.php/Market_Center.getHKStockData?page=" +
      //     that.pageCount +
      //     "&num=40&sort=changepercent&asc=0&node=qbgg_hk&_s_r_a=init",
      //   type: "GET",
      //   dataType: "json",
      //   success: function (data) {
      //     if (data.length == 0) {
      //       that.finishedQuotesDetails = true;
      //       return;
      //     }
      //     data.forEach((i) => {
      //       that.list.push(i);
      //     });
      //     that.loadingQuotesDetails = false;
      //     that.pageCount++;
      //   },
      // });
    },
    get_hk_down() {
      let that = this;
      that.loadingQuotesDetails = true;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "stock_page_data",
            action: "stock_hk_down",
            page: that.page,
            num: 40,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            if (res.data.data.length == 0) {
              that.finishedQuotesDetails = true;
            } else {
              res.data.data.forEach((e) => {
                that.dataList.push(e);
              });
              that.page++;
            }
            that.loadingQuotesDetails = false;
          } else if (res.data.code == 0) {
            that.$toast.fail(res.data.msg);
          }
        })
        .finally(() => {
          that.loadingQuotesDetails = false;
        });
      // $.ajax({
      //   cache: true,
      //   url:
      //     "https://vip.stock.finance.sina.com.cn/quotes_service/api/json_v2.php/Market_Center.getHKStockData?page=" +
      //     that.pageCount +
      //     "&num=40&sort=changepercent&asc=1&node=qbgg_hk&_s_r_a=init",
      //   type: "GET",
      //   dataType: "json",
      //   success: function (data) {
      //     if (data.length == 0) {
      //       that.finishedQuotesDetails = true;
      //       return;
      //     }
      //     data.forEach((i) => {
      //       that.list.push(i);
      //     });
      //     that.loadingQuotesDetails = false;
      //     that.pageCount++;
      //   },
      // });
    },
    get_hk_amount() {
      let that = this;
      that.loadingQuotesDetails = true;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "stock_page_data",
            action: "stock_hk_amount",
            page: that.page,
            num: 40,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            if (res.data.data.length == 0) {
              that.finishedQuotesDetails = true;
            } else {
              res.data.data.forEach((e) => {
                that.dataList.push(e);
              });
              that.page++;
            }
            that.loadingQuotesDetails = false;
          } else if (res.data.code == 0) {
            that.$toast.fail(res.data.msg);
          }
        })
        .finally(() => {
          that.loadingQuotesDetails = false;
        });
      // $.ajax({
      //   cache: true,
      //   url:
      //     "https://vip.stock.finance.sina.com.cn/quotes_service/api/json_v2.php/Market_Center.getHKStockData?page=" +
      //     that.pageCount +
      //     "&num=40&sort=amount&asc=0&node=qbgg_hk&_s_r_a=init",
      //   type: "GET",
      //   dataType: "json",
      //   success: function (data) {
      //     if (data.length == 0) {
      //       that.finishedQuotesDetails = true;
      //       return;
      //     }
      //     data.forEach((i) => {
      //       that.list.push(i);
      //     });
      //     that.loadingQuotesDetails = false;
      //     that.pageCount++;
      //   },
      // });
    },
    get_hk_volume() {
      let that = this;
      that.loadingQuotesDetails = true;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "stock_page_data",
            action: "stock_hk_volume",
            page: that.page,
            num: 40,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            if (res.data.data.length == 0) {
              that.finishedQuotesDetails = true;
            } else {
              res.data.data.forEach((e) => {
                that.dataList.push(e);
              });
              that.page++;
            }
            that.loadingQuotesDetails = false;
          } else if (res.data.code == 0) {
            that.$toast.fail(res.data.msg);
          }
        })
        .finally(() => {
          that.loadingQuotesDetails = false;
        });
      // $.ajax({
      //   cache: true,
      //   url:
      //     "https://vip.stock.finance.sina.com.cn/quotes_service/api/json_v2.php/Market_Center.getHKStockData?page=" +
      //     that.pageCount +
      //     "&num=40&sort=volume&asc=0&node=qbgg_hk&_s_r_a=init",
      //   type: "GET",
      //   dataType: "json",
      //   success: function (data) {
      //     if (data.length == 0) {
      //       that.finishedQuotesDetails = true;
      //       return;
      //     }
      //     data.forEach((i) => {
      //       that.list.push(i);
      //     });
      //     that.loadingQuotesDetails = false;
      //     that.pageCount++;
      //   },
      // });
    },
   get_hk_long() {
      let that = this;
      that.loadingQuotesDetails = true;

      that.$http({
        url: "/",
        method: "post",
        data: {
          nozzle: "trade_type_stock",
          type: 0,
          page: that.page,
          num: 40,
        },
      })
      .then((res) => {

        if (res.data.code == 1) {
          const dataObj = res.data.data || {};
          const list = Array.isArray(dataObj.list) ? dataObj.list : [];

          if (list.length === 0) {
            that.finishedQuotesDetails = true;
            return;
          }

          that.dataList.push(...list);

          that.page++;

          if (typeof dataObj.total === "number" && that.dataList.length >= dataObj.total) {
            that.finishedQuotesDetails = true;
          }

        } else {
          that.$toast.fail(res.data.msg || "API error");
        }
      })
      .catch((err) => {
        console.error(err);
        that.$toast.fail("Network error");
      })
      .finally(() => {
        that.loadingQuotesDetails = false;
      });
    },
    get_hk_short() {
      let that = this;
      that.loadingQuotesDetails = true;

      that.$http({
        url: "/",
        method: "post",
        data: {
          nozzle: "trade_type_stock",
          type: 1,
          page: that.page,
          num: 40,
        },
      })
      .then((res) => {

        if (res.data.code == 1) {
          const dataObj = res.data.data || {};
          const list = Array.isArray(dataObj.list) ? dataObj.list : [];

          if (list.length === 0) {
            that.finishedQuotesDetails = true;
            return;
          }

          that.dataList.push(...list);

          that.page++;

          if (typeof dataObj.total === "number" && that.dataList.length >= dataObj.total) {
            that.finishedQuotesDetails = true;
          }

        } else {
          that.$toast.fail(res.data.msg || "API error");
        }
      })
      .catch((err) => {
        console.error(err);
        that.$toast.fail("Network error");
      })
      .finally(() => {
        that.loadingQuotesDetails = false;
      });
    },
    
    onLoad() {
      let quotesID = this.quotesId;
      if (quotesID == 1) {
        this.get_all_stock();
        this.title = "全部港股";
        this.columnTitleOne = "代码/名称";
        this.columnTitleTwo = "最新价";
        this.columnTitleThree = "涨跌幅";
      } else if (quotesID == 2) {
        this.get_hot_hk();
        this.title = "热门港股";
        this.columnTitleOne = "代码/名称";
        this.columnTitleTwo = "最新价";
        this.columnTitleThree = "涨跌幅";
      } else if (quotesID == 3) {
        this.get_hk_up();
        this.title = "港股涨幅";
        this.columnTitleOne = "代码/名称";
        this.columnTitleTwo = "最新价";
        this.columnTitleThree = "涨跌幅";
      } else if (quotesID == 4) {
        this.get_hk_down();
        this.title = "港股跌幅";
        this.columnTitleOne = "代码/名称";
        this.columnTitleTwo = "最新价";
        this.columnTitleThree = "涨跌幅";
      } else if (quotesID == 5) {
        this.get_hk_amount();
        this.title = "港股成交额";
        this.columnTitleOne = "代码/名称";
        this.columnTitleTwo = "最新价";
        this.columnTitleThree = "成交额/万";
      } else if (quotesID == 6) {
        this.get_hk_volume();
        this.title = "港股成交量";
        this.columnTitleOne = "代码/名称";
        this.columnTitleTwo = "最新价";
        this.columnTitleThree = "成交量/万";
      } else if (quotesID == 7) {
        this.get_hk_long();
        this.title = "日可做多股";
        this.columnTitleOne = "代码/名称";
        this.columnTitleTwo = "最新价";
        this.columnTitleThree = "成交量/万";
      } else if (quotesID == 8) {
        this.get_hk_short();
        this.title = "日可做空股";
        this.columnTitleOne = "代码/名称";
        this.columnTitleTwo = "最新价";
        this.columnTitleThree = "成交量/万";
      } else {
      }
    },
  },
  mounted: function () {
    this.dataList = [];
    this.finishedQuotesDetails = false;
  },
};
</script>

<style scoped>
.navStyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}
.tablecontent {
  font-size: 14px;
  padding: 10px;
}
.tableTitle {
  font-size: 14px;
  padding-top: 5px;
  padding-left: 10px;
  padding-right: 10px;
  font-weight: bold;
}
.redText {
  color: #ff2c27;
}
.greenText {
  color: #008000;
}
</style>



// WEBPACK FOOTER //
// src/components/QuotesDetails.vue